<!--
 * @Author: DY
 * @Date: 2024-12-07 11:05:29
 * @LastEditTime: 2025-04-28 17:04:41
 * @Description: 进出场登记列表【采购管理】
 * @FilePath: \ShiMo_Mobile\src\views\purchase\entryAndExitRegister\index.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="entryAndExitRegister commonListStyles">
            <van-nav-bar
                left-arrow
                title="进出场登记"
                :style="`height: ${ $getNavHeight() }px;`"
                @click-left="swiperright"
            >
                <template #right>
                    <span class="iconfont sm-icon-test" @click="openRegisterFrom('add')"></span>
                </template>
            </van-nav-bar>
            <section>
                <van-search v-model="keyVal" placeholder="请输入搜索信息" @change="onRefresh"></van-search>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list
                        v-model="isUpLoading"
                        finished-text="没有更多了!"
                        :finished="finished"
                        @load="onLoad"
                    >
                        <ul class="list">
                            <li class="listItem" v-for="(item,index) in listData" :key="`item_${index}`">
                                <div class="engineeringInfo">
                                    <h4 class="itemTitle">
                                        <span class="iconfont iconhetong">汽运单编号：{{ item.ysd_number }}</span>
                                    </h4>
                                    <p class="itemStatus">
                                        {{ item.state_name }}
                                    </p>
                                    <div class="itemContent">
                                        <p>
                                            <img src="@/assets/images/icons/icon_28@2x.png" alt="">
                                            <span>供货单编号：{{ item.supply_number }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_7@2x.png" alt="">
                                            <span>供货日期：{{ item.supply_date }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_4@2x.png" alt="">
                                            <span>供应商：{{ item.supplier_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_18@2x.png" alt="">
                                            <span>车牌号：{{ item.plate_number }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_29@2x.png" alt="">
                                            <span>需求部门：{{ item.apply_dept_names }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_46@2x.png" alt="">
                                            <span>物料代码：{{ item.material_code }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_28@2x.png" alt="">
                                            <span>物料短描述：{{ item.material_short_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_7@2x.png" alt="">
                                            <span>进场时间：{{ item.into_time }}</span>
                                        </p>
                                    </div>
                                    <div class="itemBtn itemBtns">
                                        <template v-if="item.status === 0">
                                            <button @click="openRegisterFrom('edit', item)">
                                                编辑
                                            </button>
                                        </template>
                                        <template v-if="item.status < 3">
                                            <button @click="deleteEntryAndExitRegistery(item)">
                                                删除
                                            </button>
                                        </template>
                                        <button @click="openRegisterFrom('see', item)">
                                            查看
                                        </button>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </section>
        </div>
    </v-touch>
</template>

<script>
import { mixin_list } from '@/assets/mixin/mixin_list';
export default {
    name: 'entry-and-exit-register',
    mixins: [mixin_list],
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'entry-and-exit-register');
        }
        next();
    },
    data() {
        return {
            tableCode: 'cg_ysd_jcdj',
        };
    },
    filters: {},
    computed: {},
    watch: {},
    activated() {
        if (this.$route.params.saveCallback) {
            this.onRefresh();
        }
    },
    created() {
        this.cacheKey = Math.floor(Math.random() * 1000000000000 + 1);
    },
    mounted() {},
    methods: {
        // 查看登记表
        openRegisterFrom(type, data) {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'entryAndExitRegisterForm',
                params: {
                    type,
                    data,
                },
            });
        },
        deleteEntryAndExitRegistery(item) {
            this.$dialog.confirm({
                message: `确认删除汽运单 \n${item.ysd_number} ？`,
            }).then(async () => {
                const res = await this.deleteRequest(item.id);
                if (res) {
                    this.$toast.success('删除成功。');
                    setTimeout(() => {
                        this.onRefresh();
                    }, 500);
                }
            });
        },
        deleteRequest(id) {
            return this.$axios.$post('/interfaceApi/procurement/ysd/deletes', [id]);
        },
    },
};
</script>
<style lang="stylus">
.entryAndExitRegister
    section
        .van-pull-refresh
            height: calc(100% - 42rpx) !important
</style>
